<template>
  <div class="zones-filter">
    <div class="zones-filter-block">
      <main-text class="filter-subtitle">Факторы</main-text>

      <form v-if="analyse && analyse.filter">
        <custom-checkbox
          class="filter-checkbox"
          :key="factor.id"
          v-for="factor of factors"
          :value="Boolean(factorsFilter.includes(factor.id))"
          @input="handleFactorsCheckboxChange(factor.id)"
          :labelText="factor.name"
          v-show="analyse.factor == factor.type"
          color="secondary"
        />
      </form>
    </div>

    <div class="bittom-block">
      <div class="zones-filter-bottom-block" v-if="installations && installations.length > 0">
        <main-text class="filter-subtitle">Технологические установки</main-text>

        <form v-if="analyse && analyse.filter">
          <custom-checkbox
            class="filter-checkbox"
            :key="installation.id"
            v-for="installation in installations"
            :value="Boolean(installationsFilter.includes(installation.id))"
            @input="handleInstallationsCheckboxChange(installation.id)"
            :labelText="installation.name"
            color="secondary"
          />
        </form>
      </div>

      <div v-if="pipelines && pipelines.length > 0" class="zones-filter-bottom-block">
        <main-text class="filter-subtitle">Трубопроводы</main-text>

        <form v-if="analyse && analyse.filter">
          <custom-checkbox
            class="filter-checkbox"
            :key="pipeline.id"
            v-for="pipeline in pipelines"
            :value="Boolean(pipelinesFilter.includes(pipeline.id))"
            @input="handlePipelineCheckboxChange(pipeline.id)"
            :labelText="pipeline.name"
            color="secondary"
          />
        </form>
      </div>
    </div>

    <div class="modal-footer-buttons">
      <main-button type="button" @click="handleSaveClick()">Сохранить</main-button>
      <main-button color="link" type="button" @click="$emit('onCancelClick')">Отмена</main-button>
    </div>
  </div>
</template>
<script>
import MainText from "../../components/ui/Text.vue";
import CustomCheckbox from "../../components/ui/Checkbox.vue";
import MainButton from "../../components/ui/MainButton.vue";

export default {
  name: "zones-filter",
  components: { MainText, CustomCheckbox, MainButton },
  props: {
    installations: Array,
    pipelines: Array,
    analyse: Object,
    getZones: Function,
  },
  data() {
    return {
      factors: [
        { id: 1, name: "Пожар пролива", type: 1 },
        { id: 2, name: "Волна давления при сгорании паровоздушного облака", type: 2 },
        { id: 3, name: "Тепловое излучение пожара-вспышки", type: 1 },
        { id: 4, name: "Образование огненного шара", type: 1 },
        { id: 5, name: "Струйное горение горизонтального факела", type: 1 },
        { id: 6, name: "Струйное горение вертикального факела", type: 1 },
        { id: 7, name: "Взрыв установки с перегретой жидкостью", type: 2 },
      ],
      loaded: false,
      installationsFilter: [],
      pipelinesFilter: [],
      factorsFilter: [],
    };
  },

  created() {
    this.installationsFilter = this.reverse(this.installations, this.analyse.filter.installations);
    this.pipelinesFilter = this.reverse(this.pipelines, this.analyse.filter.pipelines);
    this.factorsFilter = this.reverse(this.factors, this.analyse.filter.factors);
    this.$nextTick(() => {
      this.loaded = true;
    });
  },
  methods: {
    reverse(data, array1) {
      if (!data) {
        return;
      }
      const array2 = [];
      for (const element of data) {
        if (!array1) {
          array2.push(element.id);
        } else if (!array1.find((el) => el == parseInt(element.id))) {
          array2.push(element.id);
        }
      }
      return array2;
    },

    handleSaveClick() {
      this.getZones();
      this.$emit("onCancelClick");
    },

    handleFactorsCheckboxChange(id) {
      if (this.factorsFilter.includes(id)) {
        this.factorsFilter = this.factorsFilter.filter((item) => item !== id);
      } else {
        this.factorsFilter.push(id);
      }
    },

    handleInstallationsCheckboxChange(id) {
      if (this.installationsFilter.includes(id)) {
        this.installationsFilter = this.installationsFilter.filter((item) => item !== id);
      } else {
        this.installationsFilter.push(id);
      }
    },

    handlePipelineCheckboxChange(id) {
      if (this.pipelinesFilter.includes(id)) {
        this.pipelinesFilter = this.pipelinesFilter.filter((item) => item !== id);
      } else {
        this.pipelinesFilter.push(id);
      }
    },
  },
  watch: {
    installationsFilter() {
      if (this.loaded) {
        this.analyse.filter.installations = this.reverse(this.installations, this.installationsFilter);
      }
    },
    factorsFilter() {
      if (this.loaded) {
        this.analyse.filter.factors = this.reverse(this.factors, this.factorsFilter);
      }
    },
    pipelinesFilter() {
      if (this.loaded) {
        this.analyse.filter.pipelines = this.reverse(this.pipelines, this.pipelinesFilter);
      }
    },
  },
};
</script>

<style scoped>
.zones-filter {
  padding: 0;
}
.filter-subtitle {
  font-weight: 500;
  margin-bottom: 12px;
}
.zones-filter-block {
  padding: 0 24px 8px;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 24px;
}
.zones-filter-bottom-block {
  padding: 0 24px 8px;
}
.filter-checkbox {
  margin-bottom: 8px;
}
.filter-checkbox:last-of-type {
  margin-bottom: 0;
}
.bittom-block {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 32px;
}
</style>
